export function dispatchEvent(root, consumerSelector, e) {
    var elementTo = root.querySelector(consumerSelector);
    if (!elementTo) {
        return;
    }
    elementTo.dispatchEvent(e);
}
export function forwardEvent(elementFrom, rootSelector, consumerSelector, e) {
    var root = elementFrom.closest(rootSelector);
    if (!root) {
        return;
    }
    dispatchEvent(root, consumerSelector, e);
}
